import React, { useEffect, useState, useRef } from 'react';
import { Container, Row, Col, Form, Button, Figure, InputGroup, Overlay, Accordion, Popover, Nav, Offcanvas, Card, Dropdown } from 'react-bootstrap';
import '../sources/styles/stylesHeader.css'
import * as Icon from 'react-bootstrap-icons';
import Cookies from 'universal-cookie';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Carrito } from '../Pages/Carrito';

function Header(props) {

    const [validateLogin, setValidateLogin] = useState(false);
    const [show, setShow] = useState(false);
    const [target, setTarget] = useState(null);
    const [text, setText] = useState('');
    const ref = useRef(null);
    const [usuario, setUsuario] = useState([]);
    const [permisoCotizacion, setPermisoCotizacion] = useState('block')
    const [permisoFiltroBuscador, setPermisoFiltroBuscador] = useState('none')
    const [espacioPedido, setEspacioPedido] = useState('none')
    const [suiteFractal, setSuiteFractal] = useState('none')
    const [suiteFractalCanvas, setSuiteFractalCanvas] = useState('none')
    const [tokenCorreo, setTokenCorreo] = useState([]);
    const [token, setToken] = useState([]);
    const [puntos, setPuntos] = useState('0');
    const [arrayRelacionGranLinea, setArrayRelacionGranLinea] = useState([]);
    const [arrayGranLinea, setArrayGranLinea] = useState([]);
    const [arrayPrueba, setArrayPrueba] = useState([]);
    const [searchType, setSearchType] = useState('catalogo');
    const [showCanvas, setShowCanvas] = useState(false);
    const [showMenu, setShowMenu] = useState(false);
    const handleClose = () => setShowCanvas(false);
    const handleShow = () => setShowCanvas(true);

    const [showCarrito, setShowCarrito] = useState(false);
    const handleCloseCarrito = () => setShowCarrito(false);
    const handleShowCarrito = () => setShowCarrito(true);

    const logo = process.env.REACT_APP_SERVER_IMAGE + 'estaticas/';
    let navigate = useNavigate();
    let location = useLocation();
    let cookies = new Cookies();

    function ParseJwt(token) {
        try {
            let base64Url = token.split('.')[1];
            let base64 = base64Url.replace('-', '+').replace('_', '/');
            let datosToken = { datos: JSON.parse(window.atob(base64)), token_key: token.split('.')[0] }
            return datosToken;
        } catch (e) {
            setPermisoFiltroBuscador('block');
            console.log('Error al generar token');
        }
    };

    function distintos(arr, indice) {
        let indices = [];
        let resultado = [];
        for (let i = 0; i < arr.length; i++) {
            if (indices.indexOf(arr[i][indice]) < 0) {
                resultado.push(arr[i]);
                indices.push(arr[i][indice]);
            }
        }
        return resultado;
    }

    const validacionToken = async () => {
        let arrayDireccion = location['pathname'].split('/');
        const accessToken = cookies.get('accesToken');
        let tok = ParseJwt(accessToken)
        if (tok !== undefined) {
            if (tok.datos.tipo_usuario !== 'temporal') {
                setTokenCorreo(tok.datos.email);
            }
            setToken(tok.token_key);
        }
        try {
            const url = process.env.REACT_APP_SERVER + '/requireAuth/validacionToken';
            const response = await axios.get(url, {
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            });
            const data = response.data;
            cookies.set('accesToken', data.accessToken, { path: '/' });
            const user = cookies.get('user')
            const ultLogo = process.env.REACT_APP_SERVER + '/api/v1/validarListaPrecio';
            const respLogo = await axios.get(ultLogo, {
                headers: {
                    "Authorization": `Bearer ${accessToken}`
                }
            });
            if (respLogo.data.lista_de_precios === '014' || respLogo.data.lista_de_precios === '010' || respLogo.data.lista_de_precios === '001') {
                setPermisoCotizacion('none');
                setPermisoFiltroBuscador('block');
                if (respLogo.data.lista_de_precios === '001') {
                    if (window.innerWidth <= 445) {
                        setSuiteFractal('none')
                    } else {
                        setSuiteFractal('block')
                    }
                    setSuiteFractalCanvas('block')
                }
                if (respLogo.data.lista_de_precios === '001') {
                    setEspacioPedido('block')
                } else {
                }
            } else {
                setPermisoCotizacion('block');
                setPermisoFiltroBuscador('none');
            }
            if (location.pathname === '/') {
                document.getElementById('logoFront').src = process.env.REACT_APP_SERVER_IMAGE + 'estaticas/logo-master.webp';
            } else {
                const imgLogo = process.env.REACT_APP_SERVER + '/api/v1/validarLogoCatalogo';
                const respImag = await axios.post(imgLogo, { lista: respLogo.data.lista_de_precios }, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                let imagenLogo = respImag.data[0].logo;
                document.getElementById('logoFront').src = logo + imagenLogo;
            }
            if (user.tipo_usuario === 'temporal') {
                setValidateLogin(false);
                setPermisoFiltroBuscador('block');
            } else {
                setValidateLogin(true);
            }
            setUsuario(user);
            setPuntos('0');
            if (respLogo.data.lista_de_precios === '001') {
                const urlPuntos = process.env.REACT_APP_SERVER + '/api/v1/customers/puntos/client';
                const resultPuntos = await axios.post(urlPuntos, respLogo.data,{
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                if (resultPuntos.data[0].puntos_positivos !== null) {
                    setPuntos(parseInt(resultPuntos.data[0].puntos_positivos) + parseInt(resultPuntos.data[0].puntos_negativos));
                }
            }
        } catch (err) {
            if (err.response.status === 403) {
                if (arrayDireccion[1] !== "" &&
                    arrayDireccion[1] !== "productSingle") {
                    cookies.remove('accesToken');
                    cookies.remove('user');
                    navigate('/inicioSesion');
                }
            }
        }
    }

    const grandesLineas = async () => {
        try {
            const accessToken = cookies.get('accesToken');
            const urlGranLiena = process.env.REACT_APP_SERVER + '/api/v1/items/gran_linea';
            const dataGranLinea = await axios.get(urlGranLiena, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            const granLinea = dataGranLinea.data[0];
            setArrayRelacionGranLinea(granLinea)
            const urlGranLienaRelacion = process.env.REACT_APP_SERVER + '/api/v1/items/gran_linea_relacion';
            const dataGranLineaRelacion = await axios.get(urlGranLienaRelacion, {
                headers: {
                    'Authorization': `Bearer ${accessToken}`
                }
            });
            const granLineaRelacion = dataGranLineaRelacion.data[0];
            setArrayPrueba(granLineaRelacion)
            let objSublinea = [];
            let objFinal = [];
            let objGranlinea = []
            for (let i = 0; i < granLineaRelacion.length; i++) {
                if (parseInt(granLineaRelacion[i].cod_granlinea) === 1) {
                    objGranlinea.push(granLineaRelacion[i]);
                }
            }
            let granLineaAux = distintos(objGranlinea, "cod_linea")
            for (let l = 0; l < granLineaAux.length; l++) {
                let objSublineaTemp = [];
                objSublinea = [];
                for (let sublinea = 0; sublinea < objGranlinea.length; sublinea++) {
                    if (granLineaAux[l].cod_linea === objGranlinea[sublinea].cod_linea) {
                        objSublineaTemp.push({
                            cod_sublinea: objGranlinea[sublinea].cod_sublinea,
                            descripcion_sublinea: objGranlinea[sublinea].descripcion_sublinea
                        })
                    }
                }
                objSublineaTemp = distintos(objSublineaTemp, "cod_sublinea")
                for (let s = 0; s < 7; s++) {
                    if (objSublineaTemp[s] === undefined) {
                        objSublinea.push({
                            cod_sublinea: '',
                            descripcion_sublinea: ''
                        });
                    } else {
                        objSublinea.push({
                            cod_sublinea: objSublineaTemp[s].cod_sublinea,
                            descripcion_sublinea: capitalizarPrimeraLetra(objSublineaTemp[s].descripcion_sublinea)
                        });
                        if (s === 6) {
                            if (objSublineaTemp[s] !== undefined) {
                                objSublinea.push({
                                    cod_sublinea: '---',
                                    descripcion_sublinea: 'VER MAS ->'
                                });
                            }
                        }
                    }
                }
                objFinal[l] = {
                    id: '1',
                    linea: {
                        cod_linea: granLineaAux[l].cod_linea,
                        nombre_linea: granLineaAux[l].descripcion_linea
                    },
                    objSublinea
                }
            }
            cookies.remove('paginas');
            setArrayGranLinea(objFinal)
        } catch (error) {
            console.log(error);
        }
    }

    const cerrarSesion = async () => {
        cookies.remove('accesToken');
        cookies.remove('user');
        cookies.remove('carrito');
        navigate('/');
        document.getElementById('logoFront').src = process.env.REACT_APP_SERVER_IMAGE + 'estaticas/logo-master.webp';
        window.location.reload();
    }

    const handleClick = (event) => {
        setShow(!show);
        setTarget(event.target);
    };

    const handleBusqueda = e => {
        setText(e.target.value);
    }

    const busquedaPromo = async (e) => {
        setText('promocional');
    }

    const busquedaItems = async (e) => {
        if (props.busquedaItems !== undefined) {
            props.busquedaItems.setImagenLinea('fondo-general');
            props.busquedaItems.setIdMarcas('0');
        }
        setShowMenu(false);
        handleClose();
        e.preventDefault();
        e.stopPropagation();
        const cookies = new Cookies();
        const accessToken = cookies.get('accesToken');
        cookies.remove('menu');
        cookies.remove('paginas');
        cookies.remove('textoBuscar');
        cookies.remove('rango');
        cookies.remove('filtro');
        cookies.set('rangoInicia', 0);
        const texto = text.replace(/'/g, "");
        try {
            const url = process.env.REACT_APP_SERVER + '/api/v1/items/busqueda';
            let body;
            if (props.busquedaItems === undefined) {
                body = { text: texto, rangoInicial: 0, rangoFinal: props.busquedaItems === undefined ? 12 : props.busquedaItems.rangoFinal };
            } else {
                body = { text: texto, rangoInicial: 0, rangoFinal: props.busquedaItems === undefined ? 12 : props.busquedaItems.rangoFinal, filtro: props.busquedaItems.filtro === 'rango' ? '' : props.busquedaItems.filtro };
                if (props.busquedaItems.filtro === 'rango') {
                    props.busquedaItems.setFiltro(undefined);
                }
            }
            let countPages = 0;
            let dataBusqueda = [];
            if (searchType === 'catalogo') {
                const urlPags = process.env.REACT_APP_SERVER + '/api/v1/items/numPags/busqueda';
                let responsePags = await axios.post(urlPags, body, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                if (responsePags.data[0] < 2 && /\D/.test(texto)) {
                    let sugerencia = 'default';
                    let responsePagsInicial = responsePags;
                    if (responsePags.data[0] === 0) {
                        const urlPalabra = process.env.REACT_APP_SERVER + '/api/v1/items/busquedaPalabra';
                        const { data } = await axios.post(urlPalabra, { text: texto }, {
                            headers: {
                                'Authorization': `Bearer ${accessToken}`
                            }
                        });
                        if (data.length === 0) {
                            const urlPalabras = process.env.REACT_APP_SERVER + '/api/v1/items/busquedaPalabras';
                            const { data } = await axios.post(urlPalabras, texto, {
                                headers: {
                                    'Authorization': `Bearer ${accessToken}`
                                }
                            });
                            function obtenerTodasLasPalabras(datos) {
                                let todasLasPalabras = new Set();
                                datos.forEach((objeto) => {
                                    let palabras = objeto.palabras_clave.split(',');
                                    palabras.forEach((palabra) => {
                                        palabra = palabra.trim();
                                        todasLasPalabras.add(palabra);
                                    });
                                });
                                return Array.from(todasLasPalabras);
                            }

                            function levenshteinDistance(str1, str2) {
                                const m = str1.length;
                                const n = str2.length;
                                const dp = Array.from(Array(m + 1), () => Array(n + 1).fill(0));
                                for (let i = 0; i <= m; i++) {
                                    dp[i][0] = i;
                                }
                                for (let j = 0; j <= n; j++) {
                                    dp[0][j] = j;
                                }
                                for (let i = 1; i <= m; i++) {
                                    for (let j = 1; j <= n; j++) {
                                        if (str1[i - 1] === str2[j - 1]) {
                                            dp[i][j] = dp[i - 1][j - 1];
                                        } else {
                                            dp[i][j] = Math.min(
                                                dp[i - 1][j - 1] + 1,
                                                dp[i][j - 1] + 1,
                                                dp[i - 1][j] + 1
                                            );
                                        }
                                    }
                                }
                                return dp[m][n];
                            }

                            function sugerirCorreccion(busqueda, listaPalabras) {
                                let sugerencias = [];
                                const umbralDistancia = 1;
                                for (const palabra of listaPalabras) {
                                    const distancia = levenshteinDistance(busqueda, palabra);
                                    if (distancia <= umbralDistancia) {
                                        sugerencias.push(palabra);
                                    }
                                }
                                return sugerencias;
                            }

                            let todasLasPalabras = obtenerTodasLasPalabras(data);
                            let correcciones = sugerirCorreccion(texto, todasLasPalabras);
                            sugerencia = correcciones.join(' ');
                        } else {
                            sugerencia = data[0].sugerencia;
                        }
                        if (sugerencia === '') {
                            sugerencia = texto;
                        }
                        if (props.busquedaItems === undefined) {
                            body = { text: sugerencia, rangoInicial: 0, rangoFinal: props.busquedaItems === undefined ? 12 : props.busquedaItems.rangoFinal };
                        } else {
                            body = { text: sugerencia, rangoInicial: 0, rangoFinal: props.busquedaItems === undefined ? 12 : props.busquedaItems.rangoFinal, filtro: props.busquedaItems.filtro };
                        }
                        responsePags = await axios.post(urlPags, body, {
                            headers: {
                                'Authorization': `Bearer ${accessToken}`
                            }
                        });
                        if (data.length === 0) {
                            let resultadosBusqueda = { text: texto, resultPaginacionI: responsePagsInicial.data[0], sugerencia: sugerencia, resultPaginacionF: responsePags.data[0] };
                            const urlInsertarBusqueda = process.env.REACT_APP_SERVER + '/api/v1/items/insertarBusqueda';
                            await axios.post(urlInsertarBusqueda, resultadosBusqueda, {
                                headers: {
                                    'Authorization': `Bearer ${accessToken}`
                                }
                            });
                        }
                    }
                }
                const { data } = await axios.post(url, body, {
                    headers: {
                        'Authorization': `Bearer ${accessToken}`
                    }
                });
                countPages = responsePags.data;
                dataBusqueda = data;
            } else {
                if (searchType === 'Ujueta') {
                    try {
                        const urlUjuetaBd = process.env.REACT_APP_SERVER + '/api/v1/items/ujueta/search/';
                        const { data: resultUjuetaBd } = await axios.post(urlUjuetaBd, { text: texto }, {
                            headers: {
                                'Authorization': `Bearer ${accessToken}`
                            },
                        });
                        if (resultUjuetaBd.result) {
                            countPages = resultUjuetaBd.productos.length;
                            dataBusqueda = resultUjuetaBd.productos;
                        } else {
                            countPages = 0;
                            dataBusqueda = [];
                        }
                    } catch (e) {
                        countPages = 0;
                        dataBusqueda = [];
                        console.error('Error al obtener la información del producto desde Ujueta:', e);
                    }
                }
            }
            let arrayAux = [];
            if (countPages[0] > 5) {
                arrayAux = [0, 1, 2, 3, 4]
            } else {
                for (let index = 0; index < countPages[0]; index++) {
                    arrayAux.push(index)
                }
            }
            let page = location.pathname.split('/')[1]
            if (page !== 'catalogo') {
                navigate('/' + searchType, { state: { data: dataBusqueda, page: '/' + page, numPags: arrayAux, limitPags: countPages, text: texto, searchType: searchType } })
                cookies.set('textoBuscar', body.text, { path: '/' });
            } else {
                if (searchType !== 'catalogo') {
                    navigate('/' + searchType, { state: { data: dataBusqueda, page: '/' + page, numPags: arrayAux, limitPags: countPages, text: texto, searchType: searchType } })
                    cookies.set('textoBuscar', body.text, { path: '/' });
                } else {
                    cookies.set('textoBuscar', body.text, { path: '/' });
                    props.busquedaItems.setTitleBusqueda(texto);
                    props.busquedaItems.setText(texto);
                    props.busquedaItems.setItems(dataBusqueda);
                    props.busquedaItems.setNumPags(arrayAux);
                    props.busquedaItems.setLimitPage(countPages);
                    props.busquedaItems.setPrecioMinimo(countPages[1]);
                    props.busquedaItems.setPrecioMaximo(countPages[2]);
                    if (cookies.get('paginas') !== undefined) {
                        props.busquedaItems.setValidacionPaginacion(cookies.get('paginas'))
                    } else {
                        props.busquedaItems.setValidacionPaginacion(1)
                    }
                    props.busquedaItems.setTextValidacion(true)
                    props.busquedaItems.setVisualizacionProductos('none')
                }
            }
        } catch (err) {
            console.log(`Ocurrió error en la consulta de busqueda items en hooks: ${err}`)
        }
    }

    const capitalizarPrimeraLetra = (str) => {
        return str.charAt(0).toUpperCase() + str.slice(1);
    }

    const queryLineas = async (id) => {
        let objSublinea = [];
        let objFinal = [];
        let objGranlinea = []
        for (let i = 0; i < arrayPrueba.length; i++) {
            if (arrayPrueba[i].cod_granlinea === id) {
                objGranlinea.push(arrayPrueba[i]);
            }
        }
        let granLinea = distintos(objGranlinea, "cod_linea")
        for (let l = 0; l < granLinea.length; l++) {
            let objSublineaTemp = [];
            objSublinea = [];
            for (let sublinea = 0; sublinea < objGranlinea.length; sublinea++) {
                if (granLinea[l].cod_linea === objGranlinea[sublinea].cod_linea) {
                    objSublineaTemp.push({
                        cod_sublinea: objGranlinea[sublinea].cod_sublinea,
                        descripcion_sublinea: objGranlinea[sublinea].descripcion_sublinea
                    })
                }
            }
            objSublineaTemp = distintos(objSublineaTemp, "cod_sublinea")
            for (let s = 0; s < 7; s++) {
                if (objSublineaTemp[s] === undefined) {
                    objSublinea.push({
                        cod_sublinea: '',
                        descripcion_sublinea: ''
                    });
                } else {
                    objSublinea.push({
                        cod_sublinea: objSublineaTemp[s].cod_sublinea,
                        descripcion_sublinea: capitalizarPrimeraLetra(objSublineaTemp[s].descripcion_sublinea)
                    });
                    if (s === 6) {
                        if (objSublineaTemp[s] !== undefined) {
                            objSublinea.push({
                                cod_sublinea: '---',
                                descripcion_sublinea: 'VER MAS ->'
                            });
                        }
                    }
                }
            }
            objFinal[l] = {
                id: id,
                linea: {
                    cod_linea: granLinea[l].cod_linea,
                    nombre_linea: granLinea[l].descripcion_linea
                },
                objSublinea
            }
        }
        cookies.remove('paginas');
        cookies.remove('textoBuscar');
        setArrayGranLinea(objFinal)
    }

    const handleDireccion = async (metodo, id, nombre, linea) => {
        setShowMenu(prevState => !prevState);
        cookies.remove('menu');
        let menu = '';
        if (id !== '---') {
            menu = `${metodo}_${id}_${nombre}_${arrayGranLinea[0].id}`;
        } else {
            menu = `masSublineas_${linea.cod_linea}_${linea.nombre_linea}`;
        }
        cookies.set('menu', menu, { path: '/' });
        if (location.pathname === "/catalogo") {
            window.location.reload();
        } else {
            navigate('/catalogo');
        }
    }

    const filtroCanvas = () => {
        return (
            <>
                <Accordion.Header><Icon.Funnel />  CATEGORIAS</Accordion.Header>
                <Accordion.Body>
                    <Accordion>
                        <Form onSubmit={(e) => busquedaItems(e)}>
                            <InputGroup className='contenidoTexto'>
                                <Button className="ps-1" onClick={busquedaPromo} type="submit" variant="default">
                                    PROMOCIONES
                                    <Form.Control hidden defaultValue={text} />
                                </Button>
                            </InputGroup>
                        </Form>
                        <Accordion.Item eventKey='50'>
                            <Accordion.Header style={{ display: permisoFiltroBuscador }} onClick={() => RemoverCooki("/Ujueta")}>TIENDA UJUETA</Accordion.Header>
                        </Accordion.Item>
                        {
                            arrayRelacionGranLinea.map((fila, id) =>
                                <Accordion.Item eventKey={id} key={id}>
                                    <Accordion.Header onClick={() => queryLineas(fila.cod_gran_linea)} >{fila.nombre}</Accordion.Header>
                                    <Accordion.Body>
                                        <Accordion>
                                            {
                                                arrayGranLinea.map((filaLinea, idLinea) =>
                                                    <Accordion.Item eventKey={idLinea} key={idLinea}>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between' }} className='contenedorCanvas'>
                                                            <Accordion.Header className='lineaCanvas' onClick={() => handleDireccion('linea', filaLinea.linea.cod_linea, filaLinea.linea.nombre_linea, '')}><small>{filaLinea.linea.nombre_linea}</small></Accordion.Header>
                                                            <Accordion.Header id={`abrirCanvas${idLinea}`} className='canvaAbrir'>
                                                                <label className='flechaCanva'> <Icon.CaretRight /></label>
                                                            </Accordion.Header>
                                                        </div>
                                                        <Accordion.Body>
                                                            <Accordion>
                                                                {
                                                                    filaLinea.objSublinea.map((fila1, id1) =>
                                                                        fila1.descripcion_sublinea !== '' &&
                                                                        (<Accordion.Item eventKey={id1} key={id1}>
                                                                            <ul onClick={() => handleDireccion('sublinea', fila1.cod_sublinea, fila1.descripcion_sublinea, filaLinea.linea)} >
                                                                                {
                                                                                    fila1.descripcion_sublinea === 'VER MAS ->'
                                                                                        ?
                                                                                        <label><b className="text-warning">{fila1.descripcion_sublinea}</b></label>
                                                                                        :
                                                                                        <label>{fila1.descripcion_sublinea}</label>
                                                                                }
                                                                            </ul>
                                                                        </Accordion.Item>
                                                                        )
                                                                    )
                                                                }
                                                            </Accordion>
                                                        </Accordion.Body>
                                                    </Accordion.Item>
                                                )
                                            }
                                        </Accordion>
                                    </Accordion.Body>
                                </Accordion.Item>
                            )
                        }
                    </Accordion>
                </Accordion.Body>
            </>
        )
    }

    const RemoverCooki = (direccion) => {
        cookies.remove('menu');
        cookies.remove('paginas');
        cookies.remove('textoBuscar');
        cookies.remove('rango');
        cookies.set('rangoInicia', 0);
        cookies.remove('filtro');
        window.location.href = direccion;
        navigate(direccion)
    }

    useEffect(() => {
        let page = location.pathname.split('/')[1]
        page === 'Ujueta' && setSearchType(page);
        validacionToken();
        grandesLineas();
        // eslint-disable-next-line
    }, []);

    return (
        <>
            <Container fluid className='bg-white border-bottom header-container pe-0 ps-4 pb-1 pt-1' style={{ paddingTop: '10px' }}>
                <Row>
                    <Col className='colFiltro'>
                        <div className='divOffCanva'>
                            <Button onClick={handleShow}  >
                                <Card.Img className='filtroMenu' alt="75x75" src={process.env.REACT_APP_SERVER_IMAGE + 'estaticas/Menu3.png'} />
                            </Button>
                            <Offcanvas show={showCanvas} onHide={handleClose}>
                                <Offcanvas.Header closeButton />
                                <Offcanvas.Body>
                                    <Link className='ms-5' to='/' width={'50%'} height={'20%'} onClick={() => RemoverCooki("/")} >
                                        <Figure.Image
                                            id='logoFront'
                                            className='image-logo'
                                            alt="171x180"
                                            src={process.env.REACT_APP_SERVER_IMAGE + 'estaticas/logo-master.webp'}
                                            width={'170'} height={'180'}
                                        />
                                    </Link>
                                    <Col className='colBuscador'>
                                        <Form onSubmit={(e) => busquedaItems(e)}>
                                            <Row>
                                                <Col xs={7} sm={7} md={7} lg={8} className='columnaBuscador pe-0'>
                                                    <Form.Control placeholder="¿Qué estás buscando hoy?" value={text} onChange={handleBusqueda} className="textBuscador ps-1" />
                                                </Col>
                                                <Col xs={5} sm={5} md={5} lg={4} className='ps-0 pe-0' style={{ position: 'relative' }}>
                                                    <Button size="sm" aria-label="Boton de busqueda" type="submit" variant="warning" id="button-addon2" className='buscar botonBuscar' style={{ position: 'absolute', right: '13px', zIndex: '1000' }}>
                                                        <Icon.Search className='ico_buscar' />
                                                    </Button>
                                                </Col>
                                            </Row>
                                        </Form>
                                    </Col>
                                    <Accordion>
                                        <Accordion.Item eventKey="0" ><Accordion.Header><Link to='/'><Icon.House />  HOME</Link></Accordion.Header></Accordion.Item>
                                        <Accordion.Item eventKey="1" >
                                            {
                                                validateLogin === true
                                                    ?
                                                    <>
                                                        <Accordion.Item eventKey="4" >
                                                            <Accordion.Header><Icon.Gear />  CONFIGURACIÓN</Accordion.Header>
                                                            <Accordion.Body>
                                                                <ul style={{ border: '2px solid black', textAlign: 'center' }}>{usuario.nombre + " " + usuario.apellido_1 + " " + usuario.apellido_2}</ul>
                                                                <ul> <Link onClick={() => handleClose()} to='/actualizarDatosUsuario'><Icon.Person />  Actualizar Datos</Link></ul>
                                                                <ul><Link onClick={() => handleClose()} to='/estadoPedidos'><Icon.BoxSeam />  Estado Pedidos</Link></ul>
                                                                <ul style={{ display: espacioPedido }}><Link onClick={() => handleClose()} to='/estadoCartera'><Icon.Wallet2 />  Estado Cartera</Link></ul>
                                                                <ul style={{ display: espacioPedido }}><Link onClick={() => handleClose()} to='/pedidoCliente'><Icon.CardList />  Pedidos Clientes</Link></ul>
                                                                <ul style={{ display: espacioPedido }}> <Link onClick={() => handleClose()} to='/informes'><Icon.JournalBookmarkFill />  Informes</Link></ul>
                                                                <ul style={{ display: permisoCotizacion }}> <Link onClick={() => handleClose()} to='/cotizacion'><Icon.ListTask />  Cotizaciones</Link></ul>
                                                                <ul></ul>
                                                            </Accordion.Body>
                                                        </Accordion.Item>
                                                        <Accordion.Item eventKey="2" >
                                                            <Accordion.Header><Link onClick={() => { handleClose(); RemoverCooki("/catalogo"); }} to='/catalogo'><Icon.FileText />  CATALOGO</Link></Accordion.Header>
                                                        </Accordion.Item>
                                                        <Accordion.Item eventKey="6">
                                                            {filtroCanvas()}
                                                        </Accordion.Item>
                                                        <Accordion.Item eventKey="3" >
                                                            <Accordion.Header><Button className="ps-0" variant="default" onClick={() => { handleClose(); handleShowCarrito(); }}><Icon.Cart />CARRITO<span className="badge badge-dark">{cookies.get('carrito')}</span></Button></Accordion.Header>
                                                        </Accordion.Item>

                                                        <Accordion.Item eventKey="5" >
                                                            <Accordion.Header style={{ display: suiteFractalCanvas }} >
                                                                <form target={'_new'} method={'post'} action={'http://bi.soferco.tech/sugerido_fractal/validarLogin.php'}>
                                                                    <input type="hidden" name="email" value={tokenCorreo} />
                                                                    <input type="hidden" name="token" value={token} />
                                                                    <button type="submit" className='btnCanvas'><Icon.Clipboard2Data /> SUITEFRACTAL</button>
                                                                </form>
                                                            </Accordion.Header>
                                                        </Accordion.Item>
                                                        <Accordion.Item eventKey="7">
                                                            <Accordion.Header>
                                                                <button onClick={() => cerrarSesion()} className='btnCanvas'>
                                                                    <Icon.BoxArrowRight />  SALIR
                                                                </button>
                                                            </Accordion.Header>
                                                        </Accordion.Item>

                                                        {/*<Accordion.Item eventKey="8">
                                                            <Accordion.Header style={{ display: suiteFractalCanvas }}>
                                                                <Link to="/catalogoPuntos">
                                                                    <Icon.Gift />   PUNTOS<span className="badge badge-dark">{puntos}</span>
                                                                </Link>
                                                            </Accordion.Header>
                                                        </Accordion.Item>*/}
                                                    </>
                                                    :
                                                    <>
                                                        <Accordion.Item eventKey="2" ><Accordion.Header><Link onClick={() => handleClose()} to='/inicioSesion'><Icon.BoxArrowInRight />  INICIO DE SESIÓN</Link></Accordion.Header></Accordion.Item>
                                                        <Accordion.Item eventKey="3" ><Accordion.Header><Link onClick={() => { handleClose(); RemoverCooki("/catalogo"); }} to='/catalogo'><Icon.FileText />  CATALOGO</Link></Accordion.Header></Accordion.Item>
                                                        <Accordion.Item eventKey="5">{filtroCanvas()}</Accordion.Item>
                                                        <Accordion.Item eventKey="4" ><Accordion.Header><Button className="ps-0" variant="default" onClick={() => { handleClose(); handleShowCarrito(); }} ><Icon.Cart />CARRITO<span className="badge badge-dark">{cookies.get('carrito')}</span></Button></Accordion.Header></Accordion.Item>
                                                    </>
                                            }
                                        </Accordion.Item>
                                    </Accordion>
                                </Offcanvas.Body>
                            </Offcanvas>
                        </div>
                    </Col>
                    <Col sm={1} md={1} lg={1} className="colBtnMenuNav">
                        <Button className="btnMenuNav" onClick={() => setShowMenu(prevState => !prevState)} variant="outline-dark">
                            <Icon.List height={'2em'} width={'2em'} />
                        </Button>
                    </Col>
                    <Col xs={6} sm={10} md={2} lg={2} className='colLogo d-flex align-items-center justify-content-center'>
                        <Link to='/' width={'80%'} height={'30%'} onClick={() => RemoverCooki("/")} >
                            <Figure.Image
                                id='logoFront'
                                className='image-logo mb-0'
                                alt="171x180"
                                src={process.env.REACT_APP_SERVER_IMAGE + 'estaticas/logo-master.webp'}
                                width={'220'} height={'220'}
                            />
                        </Link>
                    </Col>
                    <Col xs={8} sm={8} md={5} lg={5} xl={4} className='colBuscador'>
                        <Form onSubmit={(e) => busquedaItems(e)}>
                            <Row>
                                <Col xs={8} sm={7} md={7} lg={8} className='columnaBuscador pe-0'>
                                    <Form.Control placeholder="¿Qué estás buscando hoy?" value={text} onChange={handleBusqueda} className="textBuscador ps-1" />
                                </Col>
                                <Col xs={4} sm={5} md={5} lg={4} className='ps-0 pe-0' style={{ position: 'relative' }}>
                                    <Dropdown className='contenidoTexto textBuscador pe-0' style={{ display: permisoFiltroBuscador, position: 'absolute', right: '30px' }}>
                                        <Dropdown.Toggle className='dropdown-toggle ps-1 textBuscador' variant="dark">
                                            <small>{window.innerWidth <= 768 ? (<Icon.ShopWindow style={{fontSize:'14px', fontWeight:'bold'}}/>) : (searchType === 'catalogo' ? 'Ferremaster' : searchType)}</small>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu className='dropdown-menu-buscador'>
                                            <Dropdown.ItemText>Elige la tienda donde buscar:</Dropdown.ItemText>
                                            <Dropdown.Divider />
                                            <Dropdown.Item onClick={(e) => setSearchType('catalogo')}>
                                                <small>Ferremáster</small>
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={(e) => setSearchType("Ujueta")}>
                                                <small>Ujueta</small>
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                    <Button size="sm" aria-label="Boton de busqueda" type="submit" variant="warning" id="button-addon2" className='buscar botonBuscar' style={{ position: 'absolute', right: '13px', zIndex: '1000' }}>
                                        <Icon.Search className='ico_buscar' />
                                    </Button>
                                </Col>
                            </Row>
                        </Form>
                    </Col>
                    {
                        validateLogin === true
                            ?
                            <>
                                <Col xs={1} sm={1} md={1} xl={{ span: 1, offset: 1 }} className="colBtnInfoLogin iniciarSesion">
                                    <Button variant="light" className="btnInfoLogin" title="Carrito de compra" onClick={handleShowCarrito}>
                                        <div className='numberCar' id='numberCar' title="Valor Carrito">
                                            <span className="badge badge-dark">{cookies.get('carrito')}</span>
                                        </div>
                                        <Icon.Cart className="iconHeader" />
                                    </Button>
                                </Col>
                                <Col xs={1} sm={1} md={1} className="colBtnInfoLogin">
                                    <Link to='/catalogo' className="btn btn-light btnInfoLogin" title="Catalogo de compra" onClick={() => RemoverCooki("/catalogo")}>
                                        <Icon.Table className="iconHeader" />
                                    </Link>
                                </Col>
                                <Col xs={1} sm={1} md={1} className="colBtnInfoLogin">
                                    <div ref={ref}>
                                        <Button variant="light" className="btn btnInfoLogin" onClick={handleClick} title="Configuraciones">
                                            <Icon.Gear className="iconHeader" />
                                        </Button>
                                        <Overlay
                                            show={show}
                                            target={target}
                                            placement="bottom"
                                            container={ref}
                                            containerPadding={20}
                                        >
                                            <Popover>
                                                <Popover.Header as="h3">{usuario.nombre + " " + usuario.apellido_1 + " " + usuario.apellido_2}</Popover.Header>
                                                <Popover.Body>
                                                    <Row>
                                                        <Form.Group className='btnForm'>
                                                            <Col>
                                                                <Link to='/actualizarDatosUsuario' className="btn btn-light btnInfoLogin conf" title="Actualizar Datos">
                                                                    <Icon.Person /> Actualizar Datos
                                                                </Link>
                                                            </Col>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row>

                                                        <Form.Group className='btnForm'>
                                                            <Col>

                                                                <Link to='/estadoPedidos' className="btn btn-light btnInfoLogin conf" title="Estado Pedidos">
                                                                    <Icon.BoxSeam /> Estado Pedidos
                                                                </Link>
                                                            </Col>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row style={{ display: espacioPedido }}>
                                                        <Form.Group className='btnForm'>
                                                            <Col>
                                                                <Link to='/estadoCartera' className="btn btn-light btnInfoLogin conf" title="Estado Cartera">
                                                                    <Icon.Wallet2 /> Estado Cartera
                                                                </Link>
                                                            </Col>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row style={{ display: espacioPedido }}>
                                                        <Form.Group className='btnForm'>
                                                            <Col>
                                                                <Link to='/pedidoCliente' className="btn btn-light btnInfoLogin conf" title="Pedidos Clientes">
                                                                    <Icon.CardList /> Pedidos Clientes
                                                                </Link>
                                                            </Col>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row style={{ display: espacioPedido }}>
                                                        <Form.Group className='btnForm'>
                                                            <Col>
                                                                <Link to='/informes' className="btn btn-light btnInfoLogin conf" title="Pedidos Clientes">
                                                                    <Icon.JournalBookmarkFill /> Informes
                                                                </Link>
                                                            </Col>
                                                        </Form.Group>
                                                    </Row>
                                                    <Row style={{ display: permisoCotizacion }}>
                                                        <Form.Group className='btnForm'>
                                                            <Col>
                                                                <Link to='/cotizacion' className="btn btn-light btnInfoLogin conf" title="Cotizaciones">
                                                                    <Icon.ListTask /> Cotizaciones
                                                                </Link>
                                                            </Col>
                                                        </Form.Group>
                                                    </Row>
                                                </Popover.Body>
                                            </Popover>
                                        </Overlay>
                                    </div>
                                </Col>
                                {/*<Col xs={1} sm={1} md={1} className="colBtnInfoLogin suiteFractal" style={{ display: suiteFractal }}>
                                    <Link to="/catalogoPuntos" className="btn btnInfoLogin" title="Puntos">
                                        <div className='numberCar' title="Valor Puntos"><span className="badge badge-dark">{puntos}</span></div>
                                        <Icon.Gift className="iconHeader" />
                                    </Link>
                                </Col>*/}
                                <Col xs={1} sm={1} md={1} className="colBtnInfoLogin iniciarSesion">
                                    <Button variant="light" className="btn btnInfoLogin" onClick={() => cerrarSesion()} title="Cerrar sesión">
                                        <Icon.BoxArrowRight className="iconHeader" />
                                    </Button>
                                </Col>
                            </>
                            :
                            <>
                                <Col xs={1} sm={1} md={{ span: 2, offset: 1 }} className="colBtnInfoLogin iniciarSesion">
                                    <Button variant="light" className="btnInfoLogin" title="Carrito de compra" onClick={handleShowCarrito}>
                                        <div className='numberCar' id='numberCarTemporal' title="Valor Carrito">
                                            <span className="badge badge-dark">{cookies.get('carrito')}</span>
                                        </div>
                                        <Icon.Cart className="iconHeader" />
                                    </Button>
                                </Col>
                                <Col xs={1} sm={1} md={2} className="colBtnInfoLogin">
                                    <Link to='/catalogo' className="btn btn-light btnInfoLogin" title="Catalogo de compra" onClick={() => RemoverCooki("/catalogo")}>
                                        <Icon.Table className="iconHeader" />
                                    </Link>
                                </Col>
                                <Col xs={1} sm={1} md={2} className="colBtnInfoLogin">
                                    <Link to='/inicioSesion' className="btn btn-light btnInfoLogin mr-3" title="Iniciar Sesión">
                                        <Icon.Person className="icon_sesion iconHeader" />
                                    </Link>
                                </Col>

                            </>
                    }
                </Row>
                {showMenu &&
                    <Row>
                        <Col sm={4} md={3}>
                            <Form onSubmit={(e) => busquedaItems(e)}>
                                <InputGroup className='contenidoTexto'>
                                    <Button className="btnMenuGrandesLineas" onClick={busquedaPromo} type="submit" variant="default">
                                        PROMOCIONES
                                        <Form.Control hidden defaultValue={text} />
                                    </Button>
                                </InputGroup>
                            </Form>
                            {
                                arrayRelacionGranLinea.map((fila, id) =>
                                    <Button key={id} className="btnMenuGrandesLineas" onClick={() => queryLineas(fila.cod_gran_linea)} variant="default">
                                        {fila.nombre}
                                    </Button>
                                )
                            }
                            <Button className="btnMenuGrandesLineas" variant="default" style={{ display: permisoFiltroBuscador }} onClick={() => RemoverCooki("/Ujueta")}>TIENDA UJUETA</Button>
                        </Col>
                        <Col sm={1} md={1} style={{ width: "0px", height: "300px", margin: "10px 0px", padding: "1px", backgroundColor: "#EAEAEA" }}></Col>
                        <Col sm={7} md={8}>
                            <Row lg={4} sm={2} className={'filas'}>
                                {
                                    arrayGranLinea.map((filaLinea, idLinea) =>
                                        <Col className='columna' key={idLinea}>
                                            <Nav.Item>
                                                <label href='' className='lineas' onClick={() => handleDireccion('linea', filaLinea.linea.cod_linea, filaLinea.linea.nombre_linea, '')}><strong>{filaLinea.linea.nombre_linea}</strong></label>
                                                {
                                                    filaLinea.objSublinea.map((fila1, id1) =>
                                                        <Nav.Item key={id1} onClick={() => handleDireccion('sublinea', fila1.cod_sublinea, fila1.descripcion_sublinea, filaLinea.linea)} >
                                                            {
                                                                fila1.descripcion_sublinea === 'VER MAS ->'
                                                                    ?
                                                                    <label className='sublineas'><b className="text-warning">{fila1.descripcion_sublinea}</b></label>
                                                                    :
                                                                    <label className='sublineas'>{fila1.descripcion_sublinea}</label>
                                                            }
                                                        </Nav.Item>
                                                    )
                                                }
                                            </Nav.Item>
                                        </Col>
                                    )
                                }
                            </Row>
                        </Col>
                    </Row>
                }
            </Container>
            <Offcanvas show={showCarrito} onHide={handleCloseCarrito} placement="end" style={{ backgroundColor: '#f3f3f3' }}>
                <Offcanvas.Header closeButton ></Offcanvas.Header>
                <Offcanvas.Body className="p-0">
                    <Carrito />
                </Offcanvas.Body>
            </Offcanvas>
            <br /><br />
        </>
    );
}

export { Header };


